module.exports = __webpack_public_path__ + "static/media/menu.48f01512.svg";